import React, { useState } from "react";
import { Button, Dialog, DialogActions, DialogContent, Divider, Popover, Typography } from "@material-ui/core";
import CloseIcon from '@mui/icons-material/Close';
import { IconButton } from "@mui/material";
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";
import Checkbox from "@mui/material/Checkbox";
import moment from "moment";

export function SuppplyDataDialog({ open, onClose, listData }) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <Typography variant="body" className="mt-20 dialogTitle dark:bg-[#1A1F2C]">
        SUPPLIES
      </Typography>
      <Divider className="mt-10" />
      <DialogContent style={{ paddingTop: "5px", paddingBottom: "5px" }} className="dark:bg-[#1A1F2C]">
        {Array.isArray(listData) ? (
          <div>
            {listData.map((item, index) => (
              <div key={index} className="mv-10">
                <Typography variant="body" style={{ fontSize: "16px" }} className="text-[#606060] dark:text-[#F1F5F9]">{item?.title} ({item?.qty})</Typography>
              </div>
            ))}
          </div>
        ) : (
          <div>{listData}</div>
        )}
      </DialogContent>
      <DialogActions className="d-flex flex-justify-center">
        <Button variant="contained" onClick={onClose} className="ph-30 mb-15" style={{ backgroundColor: "green", color: "white", borderRadius: "10px" }}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export function SuccessGroupDeleteDialog({ open, onClose, group }) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <div className="d-flex flex-center flex-direction-column dark:bg-[#1A1F2C]">
        <DialogContent className="mb-10 mt-30 dark:bg-[#1A1F2C]" style={{ fontSize: "18px", lineHeight: "22px" }}>
          You have successfully deleted the {group?.title} Group
        </DialogContent>
        <DialogActions className="mb-20">
          <Button onClick={onClose} variant="contained" className="ph-35" style={{ backgroundColor: "green", color: "white", borderRadius: "10px" }}>
            Close
          </Button>
        </DialogActions>
      </div>
    </Dialog>
  );
};

export function CustomTooltip({ listData, title }) {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  return (
    <div>
      <Typography
        aria-owns={open ? "mouse-over-popover" : undefined}
        aria-haspopup="true"
        onClick={handleClick}
        className="color-Darkblue"
        style={{
          cursor: "pointer",
        }}
      >{title}
      </Typography>
      <Popover
        id="mouse-over-popover"
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
      >
        <div className="tooltip-heading2 p-5">
          <div className="tooltip-container2">
            {Array.isArray(listData) ? (
              <div>
                {listData.map((item, index) => (
                  <div key={index}>
                    <div> {item?.title ? item?.title : `${index + 1}. ${item?.name}`} {item?.qty ? `(${item?.qty})` : ''}</div>
                  </div>
                ))}
              </div>
            ) : (
              <div>{listData}</div>
            )}
          </div>
        </div>
      </Popover>
    </div>
  );
};

export function ConfirmationApptDialog({ open, onSingleAppt, onConfirm, modal, auth, update, onClose, client, data }) {
  // const dates = update.map(item => item.date).join(", ");
  const oldClient = client.find(cli => cli.value === auth.clientId);
  const newClient = client.find(cli => cli.value === data.clientId);
  return (
    <Dialog open={open} maxWidth="sm" fullWidth>
      <div className="d-flex flex-space-between flex-center dark:bg-[#1A1F2C]">
        <Typography variant="body" className="mt-20 dialogTitle dark:text-white">
          CONFIRMATION
        </Typography>
        <IconButton style={{ color: "red", marginRight: "20px" }} onClick={onClose} aria-label="close">
          <CloseIcon />
        </IconButton>
      </div>
      <Divider className="mt-10" />
      {/* <span>
         This is the series of appointments. Do you want to update the single appointment on{" "}
          <strong style={{ fontWeight: 'bold' }}>{auth.date}</strong>, or the series of appointments on{" "}
         <strong style={{ fontWeight: 'bold' }}>{dates}</strong>?
         </span> */}
      <DialogContent style={{ paddingTop: "5px", paddingBottom: "5px" }} className="dark:bg-[#1A1F2C]">
        {modal && (
          <div style={{ lineHeight: "1.8", fontFamily: "Arial, sans-serif", fontSize: "1rem" }} className="dark:bg-[#1A1F2C]">
            <div className="mh-10 mb-15">
              <span style={{ fontWeight: "800", fontSize: "16px" }} className="dark:text-white">
                You are rescheduling:
              </span>
            </div>
            <div className="updateDialog">
              <span className="updateDialogName dark:text-white" >Client Name:</span>
              <span className="updateDialogLabel dark:text-[#F1F5F9]">{oldClient?.label}</span>
            </div>
            <div className="updateDialog">
              <span className="updateDialogName dark:text-white">Date:</span>
              <span className="updateDialogLabel dark:text-[#F1F5F9]">{auth.apoointmentDetails.date}</span>
            </div>
            <div className="updateDialog">
              <span className="updateDialogName dark:text-white">Start Time:</span>
              <span className="updateDialogLabel dark:text-[#F1F5F9]">{auth.apoointmentDetails.time}</span>
            </div>
            <div className="updateDialog">
              <span className="updateDialogName dark:text-white">End Time:</span>
              <span className="updateDialogLabel dark:text-[#F1F5F9]">{auth.apoointmentDetails.endTime}</span>
            </div>
            <div className="updateDialog">
              <span className="updateDialogName dark:text-white">Employee Name:</span>
              <span className="updateDialogLabel dark:text-[#F1F5F9]">{auth.apoointmentDetails.calendar}</span>
            </div>

            <div style={{ margin: "10px 10px", fontWeight: "bold", fontSize: "1rem" }} className="dark:text-white">
              To:
            </div>

            <div className="updateDialog">
              <span className="updateDialogName dark:text-white">Client Name:</span>
              <span className="updateDialogLabel dark:text-[#F1F5F9]">{newClient?.label}</span>
            </div>
            <div className="updateDialog">
              <span className="updateDialogName dark:text-white">Date:</span>
              <span className="updateDialogLabel dark:text-[#F1F5F9]">{data.date}</span>
            </div>
            <div className="updateDialog">
              <span className="updateDialogName dark:text-white">Start Time:</span>
              <span className="updateDialogLabel dark:text-[#F1F5F9]">{data.time}</span>
            </div>
            <div className="updateDialog">
              <span className="updateDialogName dark:text-white">End Time:</span>
              <span className="updateDialogLabel dark:text-[#F1F5F9]">{data.endTime}</span>
            </div>
            <div className="updateDialog">
              <span className="updateDialogName dark:text-white">Employee Name:</span>
              <span className="updateDialogLabel dark:text-[#F1F5F9]">{data.calendar}</span>
            </div>
          </div>
        )}
      </DialogContent>
      <DialogActions className="mt-20 mb-15 dark:bg-[#1A1F2C]">
        <Button variant="contained" onClick={onSingleAppt} className="ph-35 mr-5" style={{ backgroundColor: "green", color: "white", borderRadius: "10px" }}>
          Update Appointment
        </Button>
        {/* <Button variant="contained" onClick={onConfirm} className="ph-35 mr-10" style={{ backgroundColor: "gray", color: "white", borderRadius: "10px" }}>
          Series Of Appointment
        </Button> */}
      </DialogActions>
    </Dialog>
  );
};


export function RescheduleDialogStep1({
  open,
  onConfirm,
  onClose,
  recurringOption,
  setRecurringOption,
  selectedAppointment
}) {
    const tz = selectedAppointment?.apoointmentDetails?.calendarTimezone || "America/New_York";
    const checkInTime = selectedAppointment?.checkInDateTime?.seconds ? moment.unix(selectedAppointment?.checkInDateTime?.seconds).tz(tz).format("hh:mm a") : null;
  return (
    <Dialog open={open} onClose={onClose}>
      <div className="d-flex flex-center flex-space-between dark:bg-[#1A1F2C] mb-8">
        <Typography
          variant="body"
          className="mt-20 dialogTitle dark:text-white"
        >
          Modify Recurring Appointment
        </Typography>

        <IconButton style={{ color: "red" }} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </div>

      <Divider />
      <DialogContent className="pv-5 dark:bg-[#1A1F2C]">
        <div className="mt-10 dark:text-white" style={{fontSize:"18px", fontWeight:"600", marginBottom:"8px"}}>This is a recurring appointment. Do you wish to modify:</div>

         <div style={{ display: "flex", flexDirection: "column", gap: "10px", marginTop: 20 }}>
            <FormControlLabel
              value="this"
              onClick={() => setRecurringOption("this")}
              control={<Radio checked={recurringOption === "this"} color="success" />}
              label={
                <div style={{ display: "flex", flexDirection: "column" }}>
                  <span className="dark:text-white" style={{ fontSize: 16, fontWeight: 500 }}>
                    This Appointment (Only)
                  </span>
                </div>
              }
            />

            <FormControlLabel
              value="some"
              control={<Radio checked={recurringOption === "some"} color="success" disabled={!!checkInTime} />}
              onClick={() => {
                if (!checkInTime) {
                  setRecurringOption("some");
                }
              }}
              disabled={!!checkInTime}
              label={
                <div style={{ display: "flex", flexDirection: "column" }}>
                  <span className="dark:text-white" style={{ fontSize: 16, fontWeight: 500 }}>
                    Some Appointments (Choose)
                  </span>
                </div>
              }
            />

            <FormControlLabel
              value="all"
              control={<Radio checked={recurringOption === "all"} color="success" disabled={!!checkInTime}/>}
              onClick={() => {
                if (!checkInTime) {
                  setRecurringOption("all");
                }
              }}
              disabled={!!checkInTime}
              label={
                <div style={{ display: "flex", flexDirection: "column" }}>
                  <span className="dark:text-white" style={{ fontSize: 16, fontWeight: 500 }}>
                    All Appointments
                  </span>
                </div>
              }
            />
        </div>
      </DialogContent>

      <DialogActions className="mt-20 mb-15 dark:bg-[#1A1F2C]">
        <Button
          variant="outlined"
          className="text-[#020817] dark:text-white dark:border-gray-500"
          style={{ borderRadius: 4 }}
          onClick={onClose}
        >
          Cancel
        </Button>

        <Button
          variant="contained"
          onClick={onConfirm}
          disabled={!recurringOption || recurringOption === ""}
          className="ml-20"
          style={{ backgroundColor: "green", color: "white", borderRadius: 4 }}
        >
          Next
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export function RescheduleDialogStep2({ open, onConfirm, onClose }) {
  return (
    <Dialog open={open} onClose={onClose}>
      <div className="d-flex flex-center flex-space-between dark:bg-[#1A1F2C] mb-8">
        <Typography
          variant="body"
          className="mt-20 dialogTitle dark:text-white"
        >
          Modify Recurring Appointment
        </Typography>

        <IconButton style={{ color: "red" }} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </div>
      <Divider />
      <DialogContent className="pv-5 dark:bg-[#1A1F2C]">
        <div className="mt-10 dark:text-white" style={{fontSize:"18px", lineHeight: 1.5, fontWeight:"600", marginBottom:"8px"}}>
            On the following screen you must select the dates you wish to modify. After the dates are selected, click the Proceed button.
        </div>
      </DialogContent>

      <DialogActions className="mt-20 mb-15 dark:bg-[#1A1F2C]">
        <Button
          variant="outlined"
          className="text-[#020817] dark:text-white dark:border-gray-500"
          style={{ borderRadius: 4 }}
          onClick={onClose}
        >
          Cancel
        </Button>

        <Button
          variant="contained"
          onClick={onConfirm}
          style={{ backgroundColor: "green", color: "white", borderRadius: 4 }}
        >
          Proceed
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export function DeleteApptDialog({
  open,
  client,
  auth,
  onClose,
  onConfirm,
  appointments
}) {
  const isRecurring = auth?.apoointmentDetails?.type === "Recurring Appointment";

  const clients = client?.find(cli => cli.id === auth.clientId);

  const [mode, setMode] = useState("single");
  const [screen, setScreen] = useState("main");
  const [selectedIds, setSelectedIds] = useState([]);

  const toggleSelect = (id) => {
    setSelectedIds(prev =>
      prev.includes(id)
        ? prev.filter(x => x !== id)
        : [...prev, id]
    );
  };
  const futureAppointments = isRecurring
    ? appointments?.filter(a => {
        const d = new Date(a?.apoointmentDetails?.date);
        return d >= new Date();
      })
    : [];

  const handleConfirm = () => {
    if (!isRecurring) {
      onConfirm([auth.id]);
      return;
    }

    if (mode === "single") {
      setSelectedIds([auth?.id]);
      onConfirm([auth?.id], mode);
    } else if (mode === "selected") {
      onConfirm(selectedIds, mode);
    } else if (mode === "future") {
      const ids = appointments?.map(a => a.id);
      setSelectedIds(ids);
      onConfirm(ids, mode);
    }
  };

  const dates = appointments?.filter(a => selectedIds.includes(a.id))?.map(a =>  moment(a.apoointmentDetails.date).format("MMM. DD, YYYY"))?.join(", ");
  const futureDates = appointments?.map(a => moment(a.apoointmentDetails.date).format("MMM. DD, YYYY"))?.join(", ");
  const formattedDateToShow = mode === "single" ? moment(auth?.apoointmentDetails?.date).format("MMM. DD, YYYY") : mode === "selected" ? dates : futureDates;

  return (
    <Dialog open={open} maxWidth="sm" fullWidth>
      <div className="d-flex flex-center flex-space-between dark:bg-[#1A1F2C] mb-8">
        <Typography variant="body" className="mt-20 dialogCancelTitle dark:text-white">
          {isRecurring && mode === "selected" ? "Cancel Recurring Appointment (Select Dates)" : mode === "future" ? "Cancel Recurring Appointment" : "Cancel this appointment"}
        </Typography>

        <IconButton style={{ color: "red" }} onClick={() => { onClose(); setSelectedIds([]);}}>
          <CloseIcon />
        </IconButton>
      </div>

      <Divider />

      <DialogContent className="pv-5 dark:bg-[#1A1F2C]">

        {!isRecurring && (
          <div style={{ lineHeight: "1.8", fontFamily: "Arial, sans-serif", fontSize: "1rem" }} className="dark:bg-[#1A1F2C]">
          <span style={{ fontWeight: "bold", fontSize: "1.1rem" }} className="dark:text-white">
            Are you sure you want to cancel this appointment?
          </span>
          <div className="updateDialog">
            <span className="updateDialogName3 dark:text-white">Client Name:</span>
            <span className="updateDialogLabel3 dark:text-[#F1F5F9]">{clients?.clientName}</span>
          </div>
          <div className="updateDialog">
            <span className="updateDialogName3 dark:text-white">Date:</span>
            <span className="updateDialogLabel3 dark:text-[#F1F5F9]">{moment(auth?.apoointmentDetails?.date).format("MMM. DD, YYYY")}</span>
          </div>
          <div className="updateDialog">
            <span className="updateDialogName3 dark:text-white">Time:</span>
            <span className={`updateDialogLabel3 dark:text-[#F1F5F9]`}>{auth.apoointmentDetails.time} </span>
          </div>
          <div className="updateDialog">
            <span className="updateDialogName3 dark:text-white">EndTime:</span>
            <span className={`updateDialogLabel3 dark:text-[#F1F5F9]`}>{auth.apoointmentDetails.endTime}</span>
          </div>
          <div className="updateDialog">
            <span className="updateDialogName3 dark:text-white">Employee Name:</span>
            <span className="updateDialogLabel3 dark:text-[#F1F5F9]">{auth.apoointmentDetails.calendar}</span>
          </div>
          <div className="updateDialog">
            <span className="updateDialogName3 dark:text-white">TimeZone:</span>
            <span className={`updateDialogLabel3 dark:text-[#F1F5F9]`}>{auth.apoointmentDetails.calendarTimezone}</span>
          </div>
          </div>
        )}

        {isRecurring && (
        <div style={{ lineHeight: 1.8 }} className="dark:text-white">
          {screen !== "final" && (
          mode === "single" ? (
            <Typography variant="body" style={{fontSize:"18px", fontWeight:"600", marginBottom:"8px"}}>
              Are you sure you want to cancel this appointment?
            </Typography>
            ) : (
            <Typography variant="body" style={{fontSize:"18px", fontWeight:"500", marginBottom:"8px"}}>
              This appointment is part of a recurring series. How would you like to proceed?
            </Typography>
          )
          )}
          <div style={{ display: "flex", flexDirection: "column", gap: "10px", marginTop: 14 }}>
          {screen === "main" && (
            <>
            <FormControlLabel
              control={<Radio checked={mode === "single"} color="success" />}
              onClick={() => { setMode("single"); setScreen("main"); }}
              label={
                <div style={{ display: "flex", flexDirection: "column" }}>
                  <span style={{ fontSize: 16, fontWeight: 500 }}>
                    Cancel only this appointment
                  </span>

                  <span style={{ fontSize: 14 }}>
                    Remove only selected appointment on{" "}
                    <strong>{auth.apoointmentDetails.date}</strong>
                  </span>
                </div>
              }
            />

            <FormControlLabel
              control={<Radio checked={mode === "selected"} color="success" />}
              onClick={() => {setMode("selected"); setScreen("select");}}
              label={<span style={{ fontSize: 16, fontWeight: 500 }}>Cancel selected dates</span>}
            />

            <FormControlLabel
              control={<Radio checked={mode === "future"} color="success" />}
              onClick={() => {setMode("future"); setScreen("main");}}
              label={
                <div style={{ display: "flex", flexDirection: "column" }}>
                  <span style={{ fontSize: 16, fontWeight: 500 }}>
                    Cancel all future appointments
                  </span>
                  <span style={{ fontSize: 14 }}>
                    Remove all remaining future appointments in this series
                  </span>
                </div>
              }
            />
            </>
          )}

          {screen === "select" && (
            <>
            {mode === "selected" && (
              <div  className="border dark:border-white"
                style={{
                  borderRadius: 6,
                  padding: 10,
                  marginLeft: 36,
                  marginTop: 14,
                  maxHeight: 180,
                  overflowY: "auto",
                }}
              >
                {appointments?.map(a => (
                  <div key={a.id} style={{ display: "flex", alignItems: "center", padding: "4px 0" }}>
                    <Checkbox
                      checked={selectedIds.includes(a.id)}
                      onChange={() => toggleSelect(a.id)}
                      color="success"
                      style={{padding:"6px"}}
                    />
                    <Typography variant="body2">
                      {a?.apoointmentDetails?.time} on {a?.apoointmentDetails?.date}
                    </Typography>
                  </div>
                ))}
              </div>
            )}
          </>
          )}

          {screen === "final" && (
            <div style={{ lineHeight: "1.8", fontFamily: "Arial, sans-serif", fontSize: "1rem" }} className="dark:bg-[#1A1F2C]">
              <span style={{ fontWeight: "bold", fontSize: "1.1rem" }} className="dark:text-white">
                Are you sure you want to cancel this appointment?
              </span>
              <div className="updateDialog mv-12">
                <span className="updateDialogName3 dark:text-white">Client Name:</span>
                <span className="updateDialogLabel3 dark:text-[#F1F5F9]">{clients?.clientName}</span>
              </div>
              <div className="updateDialog mv-10">
                <span className="updateDialogName3 dark:text-white">Date:</span>
                <span className="updateDialogLabel3 dark:text-[#F1F5F9]">{formattedDateToShow}</span>
              </div>
              <div className="updateDialog mv-10">
                <span className="updateDialogName3 dark:text-white">Time:</span>
                <span className={`updateDialogLabel3 dark:text-[#F1F5F9]`}>{auth.apoointmentDetails.time} </span>
              </div>
              <div className="updateDialog mv-10">
                <span className="updateDialogName3 dark:text-white">EndTime:</span>
                <span className={`updateDialogLabel3 dark:text-[#F1F5F9]`}>{auth.apoointmentDetails.endTime}</span>
              </div>
              <div className="updateDialog mv-10">
                <span className="updateDialogName3 dark:text-white">Employee Name:</span>
                <span className="updateDialogLabel3 dark:text-[#F1F5F9]">{auth.apoointmentDetails.calendar}</span>
              </div>
              <div className="updateDialog mv-10">
                <span className="updateDialogName3 dark:text-white">TimeZone:</span>
                <span className={`updateDialogLabel3 dark:text-[#F1F5F9]`}>{auth.apoointmentDetails.calendarTimezone}</span>
              </div>
              </div>
          )}
          </div>
        </div>
      )}
      </DialogContent>
      <DialogActions className="mt-20 mb-15 dark:bg-[#1A1F2C]">
        {isRecurring ? (
          screen === "select" ? (
          <>
            <Button variant="outlined" className="text-[#020817] dark:text-white dark:border-gray-500" style={{ borderRadius: 4 }} onClick={() => { setScreen("main"); setSelectedIds([])}}>Back</Button>

            <Button
              disabled={selectedIds.length === 0}
              variant="contained"
              onClick={() => setScreen("final")}
              style={{ backgroundColor: "green", color: "white", borderRadius: 4 }}
            >
              Confirm
            </Button>
          </>
        ) : screen === "final" ? (
          <>
            <Button
              variant="outlined"
              onClick={() => { onClose(); setScreen("main"); setSelectedIds([]);}}
              className="text-[#020817] dark:text-white dark:border-gray-500"
              style={{ borderRadius: 4 }}
            >
              Do Not Cancel
            </Button>

            <Button
              variant="contained"
              onClick={handleConfirm}
              style={{ backgroundColor: "green", color: "white", borderRadius: 4 }}
            >
              Confirm
            </Button>
          </>
        ) : (
          <>
            <Button  variant="outlined" className="text-[#020817] dark:text-white dark:border-gray-500" style={{ borderRadius: 4 }} onClick={() => { onClose(); setScreen("main"); setSelectedIds([]);}}>Cancel</Button>
            <Button variant="contained" style={{ backgroundColor: "green", color: "white", borderRadius: 4 }} onClick={() => {
                if (mode === "single" || mode === "future") {
                    setScreen("final");
                } else if (mode === "selected") {
                    setScreen("select");
                }
            }}>Confirm</Button>
          </>
        )) : (
          <>
            <Button
              variant="outlined"
              onClick={() => { onClose(); setScreen("main"); setSelectedIds([]);}}
              className="text-[#020817] dark:text-white dark:border-gray-500"
              style={{ borderRadius: 4 }}
            >
              Do Not Cancel
            </Button>

            <Button
              variant="contained"
              onClick={handleConfirm}
              style={{ backgroundColor: "green", color: "white", borderRadius: 4 }}
            >
              Confirm
            </Button>
          </>
        )}
        
      </DialogActions>
    </Dialog>
  );
}

export function DragReschduleConfirm({ open, onSingleAppt, auth, onClose, client, data, timeZones, settingsData }) {
  const clients = client.find(cli => cli.id === auth.clientId);
  const oldTimezone = timeZones.find((item) => item.value === auth.calendarTimezone)?.label
  const newTimezone = timeZones.find((item) => item.value === data.calendarTimezone)?.label
  const timeZoneConflict = oldTimezone !== newTimezone;
  return (
    <Dialog open={open} maxWidth="sm" fullWidth>
      <div className="d-flex flex-space-between flex-center dark:bg-[#1A1F2C]">
        <Typography variant="body" className="mt-20 dialogTitle dark:text-white">
          CONFIRMATION
        </Typography>
        <IconButton style={{ color: "red", marginRight: "20px" }} onClick={onClose} aria-label="close">
          <CloseIcon />
        </IconButton>
      </div>
      <Divider className="mt-10" />
      <DialogContent className="pv-5 dark:bg-[#1A1F2C]">
        <div style={{ lineHeight: "1.8", fontFamily: "Arial, sans-serif", fontSize: "1rem" }} className="dark:bg-[#1A1F2C]">
          {timeZoneConflict ?
            <div className="d-flex flex-justify-center mb-15" style={{ fontWeight: "800", fontSize: "16px", color: "red" }}>
              TimeZone Conflict
            </div>
            : null}
          <div className="d-flex mh-10 mb-15">
            <span style={{ fontWeight: "800", fontSize: "16px" }} className="dark:text-white">
              You are rescheduling:
            </span>
          </div>
          <div className="updateDialog">
            <span className="updateDialogName dark:text-white">Client Name:</span>
            <span className="updateDialogLabel dark:text-[#F1F5F9]">{clients?.clientName}</span>
          </div>
          <div className="updateDialog">
            <span className="updateDialogName dark:text-white">Date:</span>
            <span className="updateDialogLabel dark:text-[#F1F5F9]">{auth.date}</span>
          </div>
          <div className="updateDialog">
            <span className="updateDialogName dark:text-white">Time:</span>
            <span className={`updateDialogLabel dark:text-[#F1F5F9] ${timeZoneConflict ? "color-red" : ""}`}>{settingsData?.timeFormat === '24hrs' ? moment(auth.time, 'h:mm A').format('HH:mm') : auth.time} {" "} {oldTimezone.split(" ")[0]}</span>
          </div>
          <div className="updateDialog">
            <span className="updateDialogName dark:text-white">EndTime:</span>
            <span className={`updateDialogLabel dark:text-[#F1F5F9] ${timeZoneConflict ? "color-red" : ""}`}>{settingsData?.timeFormat === '24hrs' ? moment(auth.endTime, 'h:mm A').format('HH:mm') : auth.endTime} {" "} {oldTimezone.split(" ")[0]}</span>
          </div>
          <div className="updateDialog">
            <span className="updateDialogName dark:text-white">Employee Name:</span>
            <span className="updateDialogLabel dark:text-[#F1F5F9]">{auth.calendar}</span>
          </div>
          <div className="updateDialog">
            <span className="updateDialogName dark:text-white">TimeZone:</span>
            <span className={`updateDialogLabel dark:text-[#F1F5F9] ${timeZoneConflict ? "color-red" : ""}`}>{oldTimezone}</span>
          </div>

          <div style={{ margin: "10px 10px", fontWeight: "bold", fontSize: "1rem" }} className="dark:text-white">
            To:
          </div>

          <div className="updateDialog">
            <span className="updateDialogName dark:text-white">Client Name:</span>
            <span className="updateDialogLabel dark:text-[#F1F5F9]">{clients?.clientName}</span>
          </div>
          <div className="updateDialog">
            <span className="updateDialogName dark:text-white">Date:</span>
            <span className="updateDialogLabel dark:text-[#F1F5F9]">{data.date}</span>
          </div>
          <div className="updateDialog">
            <span className="updateDialogName dark:text-white">Time:</span>
            <span className={`updateDialogLabel dark:text-[#F1F5F9] ${timeZoneConflict ? "color-red" : ""}`}>{settingsData?.timeFormat === '24hrs' ? moment(data.time, 'h:mm A').format('HH:mm') : data.time} {" "} {newTimezone.split(" ")[0]}</span>
          </div>
          <div className="updateDialog">
            <span className="updateDialogName dark:text-white">EndTime:</span>
            <span className={`updateDialogLabel dark:text-[#F1F5F9] ${timeZoneConflict ? "color-red" : ""}`}>{settingsData?.timeFormat === '24hrs' ? moment(data.endTime, 'h:mm A').format('HH:mm') : data.endTime} {" "} {newTimezone.split(" ")[0]}</span>
          </div>
          <div className="updateDialog">
            <span className="updateDialogName dark:text-white">Employee Name:</span>
            <span className="updateDialogLabel dark:text-[#F1F5F9]">{data.calendar}</span>
          </div>
          <div className="updateDialog">
            <span className="updateDialogName dark:text-white">TimeZone:</span>
            <span className={`updateDialogLabel dark:text-[#F1F5F9] ${timeZoneConflict ? "color-red" : ""}`}>{newTimezone}</span>
          </div>
        </div>
      </DialogContent>
      <DialogActions className="mt-20 mb-15 dark:bg-[#1A1F2C]">
        <Button variant="contained" onClick={onSingleAppt} className="ph-35 mr-5" style={{ backgroundColor: "green", color: "white", borderRadius: "10px" }}>
          Update Appointment
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export function CompanyDetails({ open, onClose, data}) {
  return (
    <Dialog open={open} maxWidth="sm" fullWidth>
      <div className="d-flex flex-space-between flex-center dark:bg-[#1A1F2C]">
        <Typography variant="body" className="mt-20 dialogTitle dark:text-white">
          COMPANY DETAILS 
        </Typography>
        <IconButton style={{ color: "red", marginRight: "20px" }} onClick={onClose} aria-label="close">
          <CloseIcon />
        </IconButton>
      </div>
      <Divider className="mt-10" />
      <DialogContent className="pv-5 dark:bg-[#1A1F2C]">
        <div style={{ lineHeight: "1.8", fontFamily: "Arial, sans-serif", fontSize: "1rem" }} className="dark:bg-[#1A1F2C]">
          <div className="updateDialog">
            <span className="updateDialogName2 dark:text-white ">Company Name:</span>
            <span className="updateDialogLabel2  dark:text-[#F1F5F9]">{data?.companyName}</span>
          </div>
          <div className="updateDialog">
            <span className="updateDialogName2 dark:text-white">Company Email:</span>
            <span className="updateDialogLabel2  dark:text-[#F1F5F9]">{data?.email}</span>
          </div>
          <div className="updateDialog">
            <span className="updateDialogName2 dark:text-white">Company Registration Date:</span>
            <span className={`updateDialogLabel2  dark:text-[#F1F5F9]`}>{data?.date} </span>
          </div>
          <div className="updateDialog">
            <span className="updateDialogName2 dark:text-white">Product Name:</span>
            <span className={`updateDialogLabel2  dark:text-[#F1F5F9]`}>{data?.product}</span>
          </div>
          <div className="updateDialog">
            <span className="updateDialogName2 dark:text-white">Product Price:</span>
            <span className="updateDialogLabel2  dark:text-[#F1F5F9]">{data?.price}</span>
          </div>
          <div className="updateDialog">
            <span className="updateDialogName2 dark:text-white">Subscription Start Date:</span>
            <span className="updateDialogLabel2  dark:text-[#F1F5F9]">{data?.planStart}</span>
          </div>
          <div className="updateDialog">
            <span className="updateDialogName2 dark:text-white">Subscription End Date:</span>
            <span className="updateDialogLabel2  dark:text-[#F1F5F9]">{data?.planEnd}</span>
          </div>
          <div className="updateDialog">
            <span className="updateDialogName2 dark:text-white">Time Period:</span>
            <span className={`updateDialogLabel2  dark:text-[#F1F5F9]`}>{data?.period}</span>
          </div>
        </div>
      </DialogContent>
      <DialogActions className="mt-20 mb-15 d-flex flex-justify-center dark:bg-[#1A1F2C]">
        <Button variant="contained" onClick={onClose} className="ph-35 mr-5" style={{ backgroundColor: "green", color: "white", borderRadius: "10px" }}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export function CancelSubscription({ open, onConfirm, onCancel, onClose }) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <div className="d-flex flex-space-between flex-center dark:bg-[#1A1F2C]">
        <Typography variant="body" className="mt-25 dialogCancelTitle dark:text-white">
          CANCEL SUBSCRIPTION
        </Typography>
        <IconButton style={{ color: "red", marginLeft: "10px" }} onClick={onClose} aria-label="close">
          <CloseIcon />
        </IconButton>
      </div>
      <Divider className="mt-15" />
      <DialogContent className="mb-10 dark:bg-[#1A1F2C]" style={{ fontWeight: "600", fontSize: "16px", lineHeight:"1.4" }}>
        Are you sure you want to cancel subscription ?
      </DialogContent>
      <DialogActions className="mt-20 mb-15 dark:bg-[#1A1F2C]">
        <Button variant="contained" onClick={onConfirm} className="ph-35 mr-5" style={{ backgroundColor: "green", color: "white", borderRadius: "10px" }}>
        Yes
        </Button>
        <Button variant="contained" onClick={onCancel} className="ph-35 mr-10" style={{ backgroundColor: "red", color: "white", borderRadius: "10px" }}>
        No
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export function RefundSubscriptionAmount({ open, onConfirm, onCancel, onClose, data }) {

  const totalAmountPaid = data?.plan?.amount / 100;
  const startDate = data?.start_date;
  const currentDate = Math.floor(Date.now() / 1000);
  const secondsInMonth = 30 * 24 * 60 * 60;
  const monthsUsed = Math.floor((currentDate - startDate) / secondsInMonth);
  const standardMonthlyRate = 25;
  
  const amountUsed = monthsUsed * standardMonthlyRate;
  
  const refundAmount = totalAmountPaid - amountUsed;
  const refundAmountRounded = refundAmount > 0 ? refundAmount?.toFixed(2) : 0;
  
  const startDateFormatted = moment.unix(startDate).format("MMM D, YYYY");
  const todayFormatted = moment.unix(currentDate).format("MMM D, YYYY");

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <div className="d-flex flex-space-between flex-center dark:bg-[#1A1F2C]">
        <Typography variant="body" className="mt-25 dialogCancelTitle dark:text-white">
          CANCEL SUBSCRIPTION & REFUND
        </Typography>
        <IconButton style={{ color: "red", marginLeft: "10px" }} onClick={onClose} aria-label="close">
          <CloseIcon />
        </IconButton>
      </div>
      <Divider className="mt-15" />
      <DialogContent className="mb-10 dark:bg-[#1A1F2C]" style={{ fontWeight: "600", fontSize: "16px", lineHeight: "1.4" }}>
        <div>
          <div className="dark:text-white">
            You subscribed to the <strong className="dark:text-[#F1F5F9]">{data?.plan?.name}</strong> plan on{" "}
            <strong className="dark:text-[#F1F5F9]">{startDateFormatted}</strong> for <strong className="dark:text-[#F1F5F9]">${totalAmountPaid}</strong>.
          </div>
          <div className="mt-10 dark:text-white">
            You've used <strong className="dark:text-[#F1F5F9]">{monthsUsed}</strong> month{monthsUsed !== 1 ? "s" : ""} (from{" "}
            {startDateFormatted} to {todayFormatted}).
          </div>
          <div className="mt-10 dark:text-white">
            Amount used so far: <strong className="dark:text-[#F1F5F9]">${amountUsed?.toFixed(2)}</strong>
          </div>
          <div className="mt-10 dark:text-white">
            Refund amount:{" "}
            <strong style={{ color: "green" }}>${refundAmountRounded}</strong>
          </div>
          <div className="mt-20 dark:text-white">
            Are you sure you want to cancel this subscription and issue this refund?
          </div>
        </div>
      </DialogContent>
      <DialogActions className="mt-20 mb-15 dark:bg-[#1A1F2C]">
        <Button
          variant="contained"
          onClick={onConfirm}
          className="ph-35 mr-5"
          style={{ backgroundColor: "green", color: "white", borderRadius: "10px" }}
        >
          Yes, Cancel & Refund
        </Button>
        <Button
          variant="contained"
          onClick={onCancel}
          className="ph-35 mr-10"
          style={{ backgroundColor: "red", color: "white", borderRadius: "10px" }}
        >
          No
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export function UpdateSubscription({ open, onConfirm, onUpdate, onClose, additionalQuantity }) {
    return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <div className="d-flex flex-space-between flex-center dark:bg-[#1A1F2C]">
        <Typography variant="body" className="mt-25 dialogTitle dark:text-white">
          UPDATE SUBSCRIPTION
        </Typography>
        <IconButton style={{ color: "red", marginLeft: "10px" }} onClick={onClose} aria-label="close">
          <CloseIcon />
        </IconButton>
      </div>
      <Divider className="mt-15" />
      <DialogContent className="mb-10 dark:bg-[#1A1F2C] dark:text-[#F1F5F9]" style={{ fontWeight: "600", fontSize: "16px", lineHeight:"1.4" }}>
        {additionalQuantity === 0 ? "Please choose the subscription plan you would like to upgrade to." : "Are you sure you want to upgrade your subscription?"}
      </DialogContent>
      <DialogActions className="mt-20 mb-15 dark:bg-[#1A1F2C]">
        {additionalQuantity === 0 && (
          <Button variant="contained" onClick={onUpdate} className="ph-35 mr-10" style={{ backgroundColor: "#0059ff", color: "white", borderRadius: "10px" }}>
          Upgrade Storage/Users Limit
        </Button>
        )}
        <Button variant="contained" onClick={onConfirm} className="ph-35 mr-5" style={{ backgroundColor: "green", color: "white", borderRadius: "10px" }}>
          Upgrade Plan
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export function StorageLimitAccess({ open, onClose, auth }) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <Typography variant="body" className="mt-20 dialogTitle  dark:bg-[#1A1F2C] dark:text-white">
        Storage Limit Exceeded
      </Typography>
      <Divider className="mt-10" />
      <DialogContent style={{ paddingTop: "5px", paddingBottom: "5px" }} className="dark:bg-[#1A1F2C] dark:text-[#F1F5F9]">
        {auth?.userProfile?.role === "companyUser" ? "You can not upload more images as you reach out to your limit storage please upgrade package to get more space" 
        : " You can not upload image, please contact administrator" }
      </DialogContent>
      <DialogActions className="d-flex flex-justify-center dark:bg-[#1A1F2C]">
        <Button variant="contained" onClick={onClose} className="ph-30 mb-15" style={{ backgroundColor: "green", color: "white", borderRadius: "10px" }}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export function userLimitAccess({ open, onClose }) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <Typography variant="body" className="mt-20 dialogTitle dark:bg-[#1A1F2C] dark:text-white">
        User Limit Exceeded
      </Typography>
      <Divider className="mt-10" />
      <DialogContent style={{ paddingTop: "5px", paddingBottom: "5px" }} className="dark:bg-[#1A1F2C] dark:text-[#F1F5F9]">
        You've reached the user limit for your current plan. To activate additional users, please upgrade your subscription.
      </DialogContent>
      <DialogActions className="d-flex flex-justify-center dark:bg-[#1A1F2C]">
        <Button variant="contained" onClick={onClose} className="ph-30 mb-15" style={{ backgroundColor: "green", color: "white", borderRadius: "10px" }}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export function DownGradeDiaog({ open, onClose, message, onManageUsers }) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <div className="d-flex flex-space-between flex-center dark:bg-[#1A1F2C]">
        <Typography variant="body" className="mt-20 dialogTitle dark:text-white">
          Downgrade Required
        </Typography>
        <IconButton
          style={{ color: "red", marginRight: "20px" }}
          onClick={onClose}
          aria-label="close"
        >
          <CloseIcon />
        </IconButton>
      </div>
      <Divider className="mt-10" />
      <DialogContent
        style={{ paddingTop: "14px", paddingBottom: "8px" }}
        className="dark:bg-[#1A1F2C] dark:text-[#F1F5F9]"
      >
        <Typography
          variant="body2"
          style={{ whiteSpace: "pre-line", lineHeight: 1.6, fontSize: "14px", color: "#64748B" }}
          className="dark:text-[#F1F5F9]"
        >
          {message || ""}
        </Typography>
      </DialogContent>
      <DialogActions className="mt-10 mb-15 dark:bg-[#1A1F2C]">
        <Button
          variant="outlined"
          onClick={onClose}
          className="mr-10 dark:text-white dark:border-gray-400"
          style={{
            borderRadius: "5px",
            padding: "8px 16px",
            color: "white",
            borderColor: "#94A3B8",
            backgroundColor: "transparent",
          }}
        >
          Close
        </Button>
        {typeof onManageUsers === "function" && (
          <Button
            variant="contained"
            onClick={onManageUsers}
            style={{
              backgroundColor: "#16A34A",
              color: "white",
              borderRadius: "5px",
              padding: "8px 16px",
            }}
          >
            Manage Users
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
};

export function CommonConfirmationDialog({ open, onConfirm, onClose, title, message, meessge1, buttonTitle }) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <div className="d-flex flex-space-between flex-center dark:bg-[#1A1F2C]">
        <Typography variant="body" className="mt-25 dialogTitle dark:text-white">
        {title}
        </Typography>
      </div>
      <div className="mt-15 dark:bg-[#1A1F2C]"></div>
      <DialogContent className="mb-10 dark:bg-[#1A1F2C]" style={{ fontWeight: "600"}}>
        <div style={{ lineHeight:"20px", fontSize:"14px"}} className="text-[#64748B] dark:text-[#F1F5F9]">{message}</div>
        {meessge1 && (<div style={{color:"#64748B", lineHeight:"20px", fontSize:"14px", marginTop:"5px"}}>{meessge1}</div>)}
      </DialogContent>
      <DialogActions className="mt-20 mb-15 dark:bg-[#1A1F2C]">
        <Button
          type="button"
          variant="outlined"
          onClick={(e) => {
            e.preventDefault();
            onClose?.();
          }}
          className="mr-10"
          style={{ backgroundColor: "gray", color: "white", borderRadius: "5px", borderColor: "white", padding: "8px 16px" }}
        >
          Cancel
        </Button>
        <Button
          type="button"
          variant="contained"
          onClick={(e) => {
            e.preventDefault();
            onConfirm?.();
          }}
          className="mr-5"
          style={{ backgroundColor: "green", color: "white", borderRadius: "5px", padding: "8px 16px" }}
        >
          {buttonTitle || "Yes"}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export function CommonSuccessDialog({ open, onClose, title, message }) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth >
      <div className="d-flex flex-space-between flex-center dark:bg-[#1A1F2C]">
        <Typography variant="body" className="mt-25 dialogTitle  dark:text-white">
        {title}
        </Typography>
      </div>
      <div className="mt-15 dark:bg-[#1A1F2C]"></div>
      <DialogContent className="mb-10 dark:bg-[#1A1F2C]" style={{ fontWeight: "600"}}>
        <div style={{ lineHeight:"20px", fontSize:"14px"}} className="text-[#64748B] dark:text-[#F1F5F9]">{message}</div>
      </DialogContent>
      <DialogActions className="mt-20 mb-15  dark:bg-[#1A1F2C]">
        <Button variant="contained" onClick={onClose} style={{ backgroundColor: "green", color: "white", borderRadius: "5px", padding:"8px 16px"  }}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  )
}
